<template>
    <div class="user">
        <base-form class="user__form">
            <base-card class="user__details">
                <template #card__title>
                    {{ $t("global.details") }}
                </template>
                <template #card__body>
                    <div class="user__body display--grid page--single__grid">
                        <base-field
                            class="user__body__name"
                            :settings="{
                                label: {
                                    class: 'capitalize',
                                    text: $t('global.name'),
                                },
                                input: {
                                    component: 'InputBasic',
                                    id: 'name',
                                    name: 'name',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.name,
                                    browserAutocomplete: 'name',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.name,
                                    errorOnSubmit: {
                                        show: errors.api.name ? true : false,
                                        messages: errors.api.name,
                                    },
                                },
                                isEdition,
                                reset,
                                allowFilling:
                                    permissions.allowFilling ||
                                    $store.getters.isSameUser(model.id),
                            }"
                        />
                        <base-field
                            class="user__body__nif"
                            :settings="{
                                label: {
                                    class: 'capitalize',
                                    text: $t(
                                        'global.taxpayerIdentificationNumber'
                                    ),
                                },
                                input: {
                                    component: 'InputBasic',
                                    id: 'taxpayerIdentificationNumber',
                                    name: 'taxpayerIdentificationNumber',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.taxpayerIdentificationNumber,
                                    browserAutocomplete:
                                        'taxpayerIdentificationNumber',
                                    fileValidation: 'nif',
                                    errors: [
                                        {
                                            type: 'validateNIF',
                                            warning: $t('error.nif'),
                                        },
                                    ],
                                    errorOnSubmit: {
                                        show: errors.api
                                            .taxpayerIdentificationNumber
                                            ? true
                                            : false,
                                        messages:
                                            errors.api
                                                .taxpayerIdentificationNumber,
                                    },
                                },
                                isEdition,
                                reset,
                                allowFilling:
                                    permissions.allowFilling ||
                                    $store.getters.isSameUser(model.id),
                            }"
                        />
                        <base-field
                            class="user__body__cc"
                            :settings="{
                                label: {
                                    class: 'capitalize',
                                    text: $t(
                                        'global.nationalIdentificationNumber'
                                    ),
                                },
                                input: {
                                    component: 'InputBasic',
                                    id: 'nationalIdentificationNumber',
                                    name: 'nationalIdentificationNumber',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.nationalIdentificationNumber,
                                    browserAutocomplete:
                                        'nationalIdentificationNumber',
                                    errorOnSubmit: {
                                        show: errors.api
                                            .nationalIdentificationNumber
                                            ? true
                                            : false,
                                        messages:
                                            errors.api
                                                .nationalIdentificationNumber,
                                    },
                                },
                                isEdition,
                                reset,
                                allowFilling:
                                    permissions.allowFilling ||
                                    $store.getters.isSameUser(model.id),
                            }"
                        />
                        <base-field
                            class="user__body__extension"
                            :settings="{
                                label: {
                                    class: 'capitalize',
                                    text: $t(
                                        'global.freeswitchExtension'
                                    ),
                                },
                                input: {
                                    component: 'InputBasic',
                                    id: 'freeswitchExtension',
                                    name: 'freeswitchExtension',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.extension
                                }
                            }"
                        />
                        <base-field
                            class="user__body__state"
                            :settings="{
                                label: {
                                    class: 'capitalize',
                                    text: $t('global.state'),
                                },
                                input: {
                                    component: 'States',
                                    name: 'state',
                                    value: stateId,
                                    dynamicData: {
                                        states: [1, 2],
                                    },
                                },
                                isEdition,
                                reset,
                                allowFilling:
                                    isEdition && permissions.allowFilling,
                            }"
                        />
                    </div>
                </template>
            </base-card>
            <div class="user__cols display--grid page--single__half">
                <base-card class="user__contacts">
                    <template #card__title>
                        {{ $t("global.contacts") }}
                    </template>
                    <template #card__body>
                        <div
                            class="user__body display--grid page--single__half"
                        >
                            <base-field
                                class="user__body__address"
                                :settings="{
                                    label: {
                                        class: 'capitalize',
                                        text: $t('global.address'),
                                    },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'address',
                                        name: 'address',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.address,
                                        browserAutocomplete: 'address',
                                        errorOnSubmit: {
                                            show: errors.api.address
                                                ? true
                                                : false,
                                            messages: errors.api.address,
                                        },
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling:
                                        permissions.allowFilling ||
                                        $store.getters.isSameUser(model.id),
                                }"
                            />
                            <base-field
                                class="user__body__email"
                                :settings="{
                                    label: {
                                        class: 'capitalize',
                                        text: $t('global.email'),
                                    },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'email',
                                        name: 'email',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.email,
                                        browserAutocomplete: 'email',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.email,
                                        fileValidation: 'basicEmail',
                                        errors: [
                                            {
                                                type: 'email',
                                                warning: $t('error.email'),
                                            },
                                        ],
                                        errorOnSubmit: {
                                            show: errors.api.email
                                                ? true
                                                : false,
                                            messages: errors.api.email,
                                        },
                                    },
                                    isEdition,
                                    allowFilling:
                                        !isEdition && permissions.allowFilling,
                                }"
                            />
                            <base-field
                                class="user__body__mobile"
                                :settings="{
                                    label: {
                                        class: 'capitalize',
                                        text: $t('global.mobile'),
                                    },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'mobile',
                                        name: 'mobile',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: mobile,
                                        browserAutocomplete: 'mobile',
                                        errorOnSubmit: {
                                            show: errors.api.mobile
                                                ? true
                                                : false,
                                            messages: errors.api.mobile,
                                        },
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling:
                                        permissions.allowFilling ||
                                        $store.getters.isSameUser(model.id),
                                }"
                            />
                            <base-field
                                class="user__body__phone"
                                :settings="{
                                    label: {
                                        class: 'capitalize',
                                        text: $t('global.phone'),
                                    },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'phone',
                                        name: 'phone',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: phone,
                                        browserAutocomplete: 'phone',
                                        errorOnSubmit: {
                                            show: errors.api.phone
                                                ? true
                                                : false,
                                            messages: errors.api.phone,
                                        },
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling:
                                        permissions.allowFilling ||
                                        $store.getters.isSameUser(model.id),
                                }"
                            />
                        </div>
                    </template>
                </base-card>
                <base-card class="user__associations">
                    <template #card__title>
                        {{ $t("global.associations") }}
                    </template>
                    <template #card__body>
                        <div class="user__body">
                            <base-field
                                class="user__body__role"
                                :settings="{
                                    label: {
                                        class: 'capitalize',
                                        text: $t('global.role'),
                                    },
                                    input: {
                                        component: 'InputAutocomplete',
                                        id: 'roleId',
                                        name: 'roleId',
                                        type: 'text',
                                        value: role.id,
                                        targetClass:
                                            'field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.roleId,
                                        dynamicData: {
                                            data: [
                                                {
                                                    value: 2,
                                                    label: $t('roles.admin'),
                                                },
                                                {
                                                    value: 5,
                                                    label: $t('roles.auditor'),
                                                },
                                                {
                                                    value: 6,
                                                    label: $t('roles.administrativeAuditor'),
                                                },
                                                {
                                                    value: 4,
                                                    label: $t('roles.operator'),
                                                },
                                                {
                                                    value: 3,
                                                    label: $t(
                                                        'roles.supervisor'
                                                    ),
                                                },
                                            ],
                                            apiValue: {
                                                value: role.id,
                                                label: role.label
                                                    ? $t(`roles.${role.label}`)
                                                    : '',
                                            },
                                        },
                                        errorOnSubmit: {
                                            show: errors.api.roleId
                                                ? true
                                                : false,
                                            messages: errors.api.roleId,
                                        },
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: permissions.allowFilling,
                                }"
                            />
                            <base-field-with-url
                                class="user__body__parent"
                                fieldClass="user__body__parent__field"
                                :settings="{
                                    label: {
                                        class: 'capitalize',
                                        text: $t('global.responsible'),
                                    },
                                    input: {
                                        component: 'InputAutocomplete',
                                        id: 'parentId',
                                        name: 'parentId',
                                        type: 'text',
                                        value: parent.id,
                                        targetClass:
                                            'field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        isRequired: parentIsRequired,
                                        isMissing: errors.missing.parentId,
                                        dynamicData: {
                                            data: [...users],
                                            ordering: order.loading,
                                            apiValue: {
                                                label: parent.name,
                                                value: parent.id,
                                            },
                                        },
                                        errorOnSubmit: {
                                            show: errors.api.parentId
                                                ? true
                                                : false,
                                            messages: errors.api.parentId,
                                        },
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: permissions.allowFilling,
                                }"
                                :anchor="{
                                    url: `/users/${parentId}`,
                                    disable: !parentId,
                                    see: !$store.getters.isSameUser(model.id),
                                    translationKey: 'viewProfile'
                                }"
                            />
                            <base-field-with-url
                                class="user__body__client"
                                :settings="{
                                    label: {
                                        class: 'capitalize',
                                        text: $t('global.client'),
                                    },
                                    input: {
                                        component: 'InputAutocomplete',
                                        id: 'clientId',
                                        type: 'text',
                                        targetClass:
                                            'field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        isRequired: clientIsRequired,
                                        isMissing: errors.missing.clientId,
                                        dynamicData: {
                                            data: [...clients],
                                            ordering: order.loading,
                                            apiValue: {
                                                label: client.name,
                                                value: client.id,
                                            },
                                        },
                                        errorOnSubmit: {
                                            show: errors.api.clientId
                                                ? true
                                                : false,
                                            messages: errors.api.clientId,
                                        },
                                        name: 'clientId',
                                        value: client.name,
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: permissions.allowFilling && ( [ '5', '6' ].includes( payload.roleId ) || clientIsRequired )
                                }"
                                :anchor="{
                                    url: `/clients/${clientId}`,
                                    disable: !clientId,
                                    see:
                                        $store.getters.can('clients', 'see') &&
                                        clientId,
                                    translationKey: 'viewProfile'
                                }"
                            />
                        </div>
                    </template>
                </base-card>
            </div>
            <base-card class="user__observations">
                <template #card__title>
                    {{ $t("global.observations") }}
                </template>
                <template #card__body>
                    <base-field
                        :class="[
                            'user__body__observations ',
                            {
                                'background--grey--light':
                                    permissions.allowFilling,
                            },
                        ]"
                        :settings="{
                            label: {
                                class: 'field__label--hide',
                                text: $t('global.observations'),
                            },
                            input: {
                                component: 'Textarea',
                                name: 'observations',
                                id: 'observations',
                                class: 'user__body__observations__field typography--default color--default',
                                value: model.observations || '',
                                placeholder: $t('placeholders.observations'),
                                disableClass:
                                    'user__body__observations__field user__body__observations__field--disable display--block',
                            },
                            isEdition,
                            reset,
                            allowFilling: permissions.allowFilling,
                        }"
                    />
                </template>
            </base-card>
        </base-form>
        <widget-options v-if="!$route.meta.isAdd">
            <widget-button
                v-if="
                    $store.getters.can('users', 'delete') &&
                    !$store.getters.isSameUser(model.id)
                "
                :settings="{
                    action: () => toggleModal('deleteUser'),
                    label: 'deleteUser',
                }"
            />
            <widget-button
                :settings="{
                    action: () => toggleModal('changePassword'),
                    label: 'changePassword',
                }"
            />
        </widget-options>
        <modal
            v-if="modal.show"
            :form="{
                class: 'modal__form--action display--flex',
                settings: {
                    submissionType: modal[modal.type].action,
                },
            }"
            :customSettings="{
                color: 'red',
                button: {
                    label: 'confirm',
                },
            }"
            :executeCloseAction="!modal.loading"
            @close="toggleModal(modal.type)"
            :key="modal.show"
        >
            <template #modal__header>
                <h2 class="modal__header">{{ $t("global.confirm") }}</h2>
            </template>
            <template #modal__body>
                {{ $t(`warning.${modal.type}`) }}
            </template>
            <template #modal__info>
                <base-button
                    class="
                        modal__content__button--negative
                        background--transparent
                        border--grey
                    "
                    :class="{ disable: modal.loading }"
                    @click="toggleModal(modal.type)"
                    v-html="$t('global.cancel')"
                />
            </template>
        </modal>
    </div>
</template>

<script>
// package
import {
    reactive,
    toRefs,
    watch
    // onMounted
} from '@vue/composition-api';

// hooks
import { singleStructure, useData } from '@/hooks/use-data';
import { generateConfigsToUsersAndClients, useLists } from '@/hooks/get-lists';
import { getContacts } from '@/hooks/use-contacts';

// store
import { mapState, storePayload, useActions } from '@/hooks/use-store';

// models
import { toggleRequiredFields } from '@/models/helpers/toggle-required-fields';

// configs
import { roleList } from '@/configs/const';

// helpers
import { sortObjectsArray } from '@/helpers/mixinGeneral';

// TODO: activar o ver perfil para utilizadores.
// TODO: activar o ver perfil para clientes.
// TODO: alteração de password.
export default {
    components: {
        ...singleStructure.components,
        WidgetButton: () => import( /* webpackChunkName: 'WidgetButton' */ '@/components/bundles/layout/widget/options/types/WidgetButton' ),
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' ),
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' ),
        BaseFieldWithUrl: () => import( /* webpackChunkName: 'BaseFieldWithUrl'  */ '@/components/bundles/fields/BaseFieldWithUrl' )
    },
    props: {
        ...singleStructure.props
    },
    setup ( props, { root: { $route, $router } }) {
        // obtenção das listagens
        const { users, clients, order } = useLists( generateConfigsToUsersAndClients( props.permissions.allowFilling, { props, route: $route }) );

        const state = reactive({
            client: {},
            initialClient: {},
            clientId: '',
            role: { id: '', label: '' },
            stateId: 1,
            parent: {},
            parentId: '',
            parentIsRequired: false,
            clientIsRequired: false,
            payload: mapState({ module: 'storePayload', key: 'payload' }),
            usersTimerInterval: null,
            clientsTimerInterval: null
        });

        // ordenar drop de users
        state.usersTimerInterval = setInterval( () => {
            if ( users?.value?.length ) {
                sortObjectsArray( users.value );
                clearInterval( state.usersTimerInterval );
            }
        }, 700 );

        // ordenar drop de clients
        state.clientsTimerInterval = setInterval( () => {
            if ( clients && clients.value.length ) {
                sortObjectsArray( clients.value );
                clearInterval( state.clientsTimerInterval );
            }
        }, 700 );

        const contacts = reactive({
            mobile: '',
            phone: ''
        });

        // obtenção das acçõs da store
        const { actions } = useActions();

        const structureData = newModel => {
            // se não exister novo model,
            // não é necessário executar o resto do código.
            if ( !Object.keys( newModel ).length )
                return;

            // obtenção dos dados do cliente associado
            // ao utilizador.
            if ( newModel.client ) {
                state.client = { ...newModel.client };
                state.client.id = state.client.id.toString();
                state.clientId = newModel.client.id;
                state.initialClient = { ...state.client };
            }

            if ( newModel.parent ) {
                state.parent = newModel.parent;
                state.parent.id = state.parent.id.toString();
                state.parentId = newModel.parent.id;
            }

            // obtenção dos contactos proveniente da API.
            getContacts({ apiContacts: newModel.contacts, contacts });

            // definição do helper.
            actions( 'saveHelper', { contacts: newModel.contacts });

            // definição da label do role
            state.role.id = newModel.role.id.toString();
            state.role.label = roleList[newModel.role.id];

            // Permitir ou bloquear campo do cliente consoante a sua role.
            if ( state.role.id === '5' || state.role.id === '6' )
                state.clientIsRequired = true;

            state.stateId = newModel.state.id;
        };

        useData( props, structureData );

        // validação se o campo responsável deve ser
        // obrigatório ou não. Caso o roleId selecionado seja diferente de
        // 2 ( admin ) então o campo é obrigatório.
        const requiredParentToggle = roleId => {
            const rolesWithoutParentRequired = [ 2 ]; // admin

            const isRequired = !rolesWithoutParentRequired.includes( parseInt( roleId, 10 ) );

            toggleRequiredFields( 'user', { field: 'parentId', isRequired });
            state.parentIsRequired = isRequired;
        };

        // validação se o campo cliente deve ser
        // obrigatório ou não. Caso o roleId selecionado seja
        // 5 ( auditor ) então o campo é obrigatório.
        const requiredClienttToggle = roleId => {
            const rolesWithClientRequired = [ 5, 6 ]; // admin

            const isRequired = rolesWithClientRequired.includes( parseInt( roleId, 10 ) )
                || ( roleId === undefined && ( props?.model?.role?.id === 5 || props?.model?.role?.id === 6 ) );

            toggleRequiredFields( 'user', { field: 'clientId', isRequired, isRequiredOnEdit: isRequired });
            state.clientIsRequired = isRequired;
        };

        // Verifica se o responsável e/ ou o cliente são obrigatórios.
        const checkRequiredFields = roleId => {
            requiredParentToggle( roleId );
            requiredClienttToggle( roleId );
        };

        // Função que atualiza os valores do cliente consoante o role escolhido.
        const handleClientValues = roleId => {
            if ( props.isEdition ) {
                const oldRoleId = props.model?.role?.id;

                if ( oldRoleId === 5 || oldRoleId === 6 ) {
                    if ( roleId === undefined ) {
                        actions( 'deleteField', { name: 'clientId' });
                        state.client = { ...state.initialClient };
                    } else {
                        actions( 'registerField', { name: 'clientId', value: '' });
                        state.client = {};
                    }
                }
            }
        };

        // Processa todas as operações necessárias a
        // serem feitas após a alteração de um role.
        const handleRoleChanges = roleId => {
            checkRequiredFields( roleId );
            handleClientValues( roleId );
        };

        // Ao alterar o role
        // -> Verificar se o responsável é obrigatório ou não
        // -> Verificar se o cliente é obrigatório ou não
        // -> Se for edição e tiver mudado de auditor para outro role,
        // coloca e envia o cliente a null.
        watch( () => state.payload.roleId,
            handleRoleChanges );

        const { errors, reset } = storePayload();

        // modal
        const modal = reactive({
            show: false,
            loading: mapState({ module: 'storePayload', key: 'loading' }),
            type: 'changePassword',
            changePassword: {
                field: {
                    name: 'email',
                    value: props.model.email
                },
                action: 'requestResetPassword'
            },
            deleteUser: {
                field: {
                    name: 'endpoint',
                    value: '/users'
                },
                action: 'processDelete'
            }
        });

        /**
         * [method]
         * Toggle da modal proveninente do widget.
         *
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const toggleModal = type => {
            // obtenção do campo para ser enviado para a store.
            const { field } = modal[type];

            modal.type = type;
            modal.show = !modal.show;

            // bloqueia a barra de adição / edição
            actions( 'controlActionBar', { value: modal.show });

            // Caso acção seja abrir a modal, e conforme
            // o tipo da modal, é adicionado a informação ao payload.
            // Caso acção seja fechar a modal, é removido todo o payload da store.
            ( modal.show )
                ? actions( 'registerField', field )
                : actions( 'resetState', false );
        };

        // obtenção do trigger
        const trigger = mapState({ module: 'storePayload', key: 'trigger' });

        // validação de quando o trigger é activo
        // de forma a fechar a modal.
        watch( () => trigger.value,
            newTrigger => {
                if ( newTrigger ) {
                    modal.show = false;

                    // se acção for de apagar o utilizador
                    // é necessário fazer o redirect para a listagem de
                    // utilizadores.
                    if ( modal.type === 'deleteUser' )
                        setTimeout( () => { $router.push({ name: 'users' }); }, 5100 );
                }
            });

        return {
            ...toRefs( state ),
            ...toRefs( contacts ),
            users,
            clients,
            order,
            errors,
            reset,
            modal,
            toggleModal
        };
    }
};
</script>

<style lang="scss">
.user {
    &__cols {
        margin: 30px 0;
    }
    &__body {
        row-gap: 40px;
        &__role {
            max-width: calc(50% - 10px);
            z-index: 5;
        }
        &__parent {
            margin: 40px 0;
            &__field {
                z-index: 4;
            }
        }
        &__address {
            grid-column: 1 / -1;
        }
        &__observations {
            @include rounded-corner(19px);
            &__field {
                height: 200px;
                &--disable {
                    padding-top: 10px;
                }
            }
        }
    }
}
</style>